import { Box } from '@mui/material'
import { DataGrid, GridColDef, GridRowsProp } from '@mui/x-data-grid'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import CustomChip from '../../../../../../shared/components/CustomChip'
import useScreenWidth from '../../../../../../shared/hooks/useScreenWidth'
import { IRootState } from '../../../../../../../redux/types'

interface ISystemLogsList {
  id: number
  created_by: string
  name: string
  actionId: number
  data: any
  date: string
}

export function SystemLogsTable() {
  const { t } = useTranslation(['global'])
  const isMobile = useScreenWidth(700)

  const { logs } = useSelector((state: IRootState) => state.log)

  const initialState = {
    columns: {
      columnVisibilityModel: {
        data: !isMobile
      }
    }
  }

  const rows: GridRowsProp<ISystemLogsList> = logs.filter((log: ISystemLogsList) => [3, 4, 5, 6, 14].includes(log.actionId)) ?? []
  const columns: GridColDef[] = [
    { headerName: 'Encargado', field: 'created_by', flex: 1 },
    {
      headerName: t('action'),
      field: 'name',
      flex: 1,
      renderCell: (params: any) => (
        <Box display="flex" alignItems="center" gap={8} height={24} p={1}>
          {[3, 5, 14].includes(params.row.actionId) && <CustomChip type={2} color="primary" label={params.value} />}
          {params.row.actionId === 4 && <CustomChip type={2} color="secondary" label={params.value} />}
          {params.row.actionId === 6 && <CustomChip type={2} color="default" label={params.value} />}
        </Box>
      )
    },
    { headerName: t('data'), field: 'data', flex: 1 },
    { headerName: t('date'), field: 'date', flex: 1 }
  ]

  return <DataGrid rows={rows} columns={columns} disableColumnMenu initialState={initialState} />
}
